/**
 * Optional backend persistence hook for a language choice.
 *
 * Kept as a settable callback so the infra layer never imports `@services`
 * (an upward dependency, forbidden by the layering rules). `@services` registers
 * the implementation at app startup via `setLanguagePersistence`, and
 * `useLanguageSwitch` awaits `persistLanguageChoice` BEFORE reloading — otherwise
 * the reload would cancel the in-flight persist request.
 */
type LanguagePersistence = (language: string) => Promise<void>;

let persistence: LanguagePersistence | null = null;

/** Register (or clear) the persistence implementation. Called once at startup. */
export function setLanguagePersistence(fn: LanguagePersistence | null): void {
  persistence = fn;
}

/** Run the registered persistence hook, if any. Never throws for a missing hook. */
export async function persistLanguageChoice(language: string): Promise<void> {
  if (persistence) await persistence(language);
}
